// extracted by mini-css-extract-plugin
module.exports = {"Fatture":"Fatture__Fatture__[hash_base64-5]","Title":"Fatture__Title__[hash_base64-5]"};